import React from 'react';
import { Helmet } from 'react-helmet-async';
import { hreflangAlternates } from '../utils/seoLocale';

export default function SeoAlternateLinks({ pathWithoutLocale }) {
  const alts = hreflangAlternates(pathWithoutLocale);
  return (
    <Helmet>
      {alts.map(({ hrefLang, href }) => (
        <link key={hrefLang} rel="alternate" hrefLang={hrefLang} href={href} />
      ))}
    </Helmet>
  );
}
